import script from "./AppInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppInput.vue?vue&type=script&setup=true&lang=ts"

import "./AppInput.vue?vue&type=style&index=0&id=2ab085b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ab085b4"]])

export default __exports__